// Application constants
export const API_ENDPOINTS = {
  RAG_BASE: 'https://wallst.co.il/api',  // Production backend
  RESEARCH_BASE: 'https://wallst.co.il/api',  // Production backend
  SUPABASE_URL: 'https://vndaufxufftwkdiwjgji.supabase.co',
} as const;

export const DEFAULT_CONFIG = {
  API_TIMEOUT: 30000,
  MAX_QUESTION_LENGTH: 1000,
  MAX_DOCUMENT_TITLE_LENGTH: 100,
  DEFAULT_LANGUAGE: 'English' as const,
  DEFAULT_PROVIDER: 'gemini' as const,
} as const;

// Update the FILTER_OPTIONS to match the expected types
export const FILTER_OPTIONS = {
  ALL_SECTORS: { id: 0, name: 'All Sectors' } as const,
  ALL_ANALYSTS: { id: 0, name: 'All Analysts' } as const,
  ALL_COMPANIES: { id: 0, name: 'All Companies', ticker: '' } as const,
  ALL_TICKERS: { id: 0, name: 'All Tickers', ticker: '' } as const,
} as const;

export const UI_CONSTANTS = {
  DEBOUNCE_DELAY: 300,
  COPY_TIMEOUT: 2000,
  MAX_CHAT_HISTORY: 50,
  SCROLL_THRESHOLD: 100,
} as const;

export const ERROR_MESSAGES = {
  FETCH_DOCUMENTS_FAILED: 'Failed to fetch documents from database',
  FETCH_FILTERS_FAILED: 'Failed to fetch filters',
  ASK_QUESTION_FAILED: 'Failed to get answer',
  GENERATE_SUMMARY_FAILED: 'Failed to generate summary',
  NETWORK_ERROR: 'Network error - please check your connection',
  UNKNOWN_ERROR: 'An unknown error occurred',
  // New fallback system error messages
  TIMEOUT_ERROR: 'The system is busy right now. Please try again in a minute or two.',
  RATE_LIMIT_ERROR: 'We\'ve reached the service usage limit. Please try again in a few minutes.',
  AUTH_ERROR: 'System authentication issue. Please contact support.',
  NETWORK_ERROR_FALLBACK: 'Temporary network issue. Check your connection and try again.',
  NO_PROVIDER_ERROR: 'LLM service not available. Please try again later.',
} as const;

export const GUIDANCE_MESSAGES = {
  TIMEOUT: 'If the problem persists, try asking a shorter question or summarizing a shorter document.',
  RATE_LIMIT: 'If you need an urgent answer, try asking a shorter question.',
  AUTH: 'This will be resolved soon. In the meantime, try again in a few minutes.',
  NETWORK: 'If the problem persists, try again in a few minutes.',
  UNKNOWN: 'If the problem persists, contact support.',
  NO_PROVIDER: 'The system will be back online soon. Please try again later.',
} as const;

export const SUCCESS_MESSAGES = {
  COPIED_TO_CLIPBOARD: 'Copied to clipboard',
  SUMMARY_GENERATED: 'Summary generated successfully',
  QUESTION_ASKED: 'Question processed successfully',
  CACHED_RESPONSE: 'Using cached response for faster results',
  FALLBACK_RESPONSE: 'Using fallback provider for faster response',
} as const;

export const PROVIDER_LABELS = {
  gemini: 'Gemini',
  openai: 'OpenAI',
  'gemini+openai': 'Gemini + OpenAI Styling',
  'gemini_only': 'Gemini (Fast Mode)',
  'openai_fallback': 'OpenAI (Fallback)',
  fallback: 'Fallback System',
} as const; 